module.exports = __webpack_public_path__ + "img/event_long-2.6a0319eb.jpg";